import { type YDatabase } from '@databases/collab/y-database';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types';

/**
 * Rejects duplicate entry IDs. Returns `STATE_ERROR('ENTRY_ALREADY_EXISTS')`
 * when the id is already present in the document; otherwise `ok`.
 */
export function assertEntryNotExists(
  ydb: YDatabase,
  entryId: string
): Result<void, SdkError> {
  if (ydb.entriesById[entryId]) {
    return err({
      type: 'STATE_ERROR',
      reason: 'ENTRY_ALREADY_EXISTS',
      message: `Entry '${entryId}' already exists`,
    });
  }

  return ok(undefined);
}
